import isGitUrl from 'is-git-url';
import { InvalidArgumentError } from '@commander-js/extra-typings';

export function validateGitUrl(value: string) {
  if (isGitUrl(value)) {
    return value;
  }

  throw new InvalidArgumentError('Value must be a valid Git URL');
}
